const _ = 2, E = "OfflineDB", D = "id,space_id", N = "data_id,page_id,space_id";
export {
  _ as DB_VERSION,
  N as ITEM_PAGE_DATA_CONTENT_INDEXED_SCHEMA,
  E as OFFLINE_DB,
  D as PAGE_CONTENT_INDEXED_SCHEMA
};
